import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

import { computed, ref } from "vue";
import { MemberRoleButtonProps, MemberRole } from "@/types";
import { memberRoleOptions } from "@/util";
import { memberApiStore } from "@/hooks";
import { TextButton, ListItem, Icon, List } from "@/components/common";


/**
 * A dropdown button for editing member roles.
 */
const __default__ = {
  name: "MemberRoleButton",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    member: {}
  },
  setup(__props: any) {

const props = __props;

const projectRoles = computed(() => memberRoleOptions(props.member.entityType));

const loading = ref(false);

/**
 * Updates the project member's role.
 */
function handleSave(role: MemberRole) {
  loading.value = true;

  memberApiStore.handleSaveRole(
    { ...props.member, role },
    {
      onComplete: () => (loading.value = false),
    }
  );
}

return (_ctx: any,_cache: any) => {
  const _component_q_menu = _resolveComponent("q-menu")!

  return (_openBlock(), _createBlock(_unref(TextButton), {
    text: "",
    icon: "permission",
    label: props.member.role,
    loading: loading.value,
    "data-cy": "button-member-role"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Icon), {
        variant: "down",
        size: "xs"
      }),
      _createVNode(_component_q_menu, null, {
        default: _withCtx(() => [
          _createVNode(_unref(List), null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectRoles.value, (role) => {
                return (_openBlock(), _createBlock(_unref(ListItem), {
                  key: role.id,
                  clickable: "",
                  title: role.id,
                  subtitle: role.name,
                  onClick: ($event: any) => (handleSave(role.id as MemberRole))
                }, null, 8, ["title", "subtitle", "onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["label", "loading"]))
}
}

})